import { render, staticRenderFns } from "./PostRatingScreen.vue?vue&type=template&id=4429973e&scoped=true&"
import script from "./PostRatingScreen.vue?vue&type=script&lang=js&"
export * from "./PostRatingScreen.vue?vue&type=script&lang=js&"
import style0 from "./PostRatingScreen.vue?vue&type=style&index=0&id=4429973e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4429973e",
  null
  
)

export default component.exports